import Button from "../Button/Normal/Button";
import { handleFileDownload } from "./static/ts/handleFileDownload";

const ImageZipDownload = (
    {
        brand_id,
        upload_file_pk,
        file_name,
        file_size,
    }:{
        brand_id: number;
        upload_file_pk: number;
        file_name?: string;
        file_size?: number;
    }
) => {

    return(
        <Button
            preset={"save"}
            onClick={() => handleFileDownload({ brand_id, upload_file_pk, file_name, file_size })}
            isHidden={"mobile"}
            size={"size3"}
        >
            사진 다운로드
        </Button>
    )
}

export default ImageZipDownload;